import Group from '../group.js';

/**
 * Create the action
 */

const { thunk, request, success, error } = Group.update((data, fetch) => {

    if(data.updateGroup === true) {
        return fetch.patch(`groups/${data.groupId}`, data);
    }
    
    if(data.deleteFile === true) {
        return fetch.delete(`groups/file/${data.fileId}`);
    }

    if(data.updateFile === true) {
        return fetch.patch(`groups/file/${data.fileId}`, data);
    }

    const formData = new FormData();
    formData.append('file', data.file);
    return fetch.post(`groups/file/${data.groupId}`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
